import { DayPreset, RangePreset } from '../../types/types';
import { FilterData } from '../../components/FilterForm/FilterForm';
import { getDefaultDateFilterValues } from './getDefaultDateFilterValues';
import { getTimespanFromRange } from './getTimespanFromRange';

export const getDefaultFilterData = (filter) => {
  let values = ['DATE', 'DATERANGE'].includes(filter.type)
    ? getDefaultDateFilterValues(filter)
    : filter.defaultValue
      ? filter.defaultValue
      : [];
  if (!Array.isArray(values)) {
    values = [values.toString()];
  }
  if (!values.length) {
    return null;
  }
  if (['SELECT', 'MULTISELECT'].includes(filter.type)) {
    if (!filter.availableValues?.length) {
      return null;
    }
    // Remove items from defaultValue that are not included in availableValues
    values = values.filter((value) => {
      const foundAvailableValue = filter.availableValues.find(
        (availableValue) => availableValue.key === value
      );
      return !!foundAvailableValue;
    });
  }
  const filterData: FilterData = {
    id: filter.id,
    values,
  };
  if (['DATE', 'DATERANGE'].includes(filter.type)) {
    let correctDefaultNamedRange = false;
    if (filter.defaultNamedRange) {
      correctDefaultNamedRange = Object.values(
        filter.type === 'DATERANGE' ? RangePreset : DayPreset
      ).includes(filter.defaultNamedRange);
    }
    if (correctDefaultNamedRange) {
      filterData.namedRange = filter.defaultNamedRange;
    } else if (filter.type === 'DATE') {
      const day = new Date(values[0]);
      const namedRange = getTimespanFromRange(day, day, false);
      if (namedRange) {
        filterData.namedRange = namedRange.id;
      }
    } else {
      const namedRange = getTimespanFromRange(
        new Date(values[0]),
        new Date(values[1]),
        true
      );
      if (namedRange) {
        filterData.namedRange = namedRange.id;
      }
    }
  }
  return filterData;
};
